import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

export function ChatWidget() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin") || location.pathname.startsWith("/portal");

  useEffect(() => {
    if (isAdmin) {
      // Hide widget on admin pages
      const bubble = document.getElementById("gr-chat-bubble");
      const win = document.getElementById("gr-chat-window");
      if (bubble) bubble.style.display = "none";
      if (win) win.style.display = "none";
      return;
    }

    // Show widget on non-admin pages
    const bubble = document.getElementById("gr-chat-bubble");
    if (bubble) {
      bubble.style.display = "flex";
      return; // Already loaded
    }

    // Load widget script
    const script = document.createElement("script");
    script.src = `${API}/api/widget/chat.js`;
    script.async = true;
    script.id = "gr-chat-script";
    document.body.appendChild(script);
  }, [isAdmin, location.pathname]);

  return null;
}
